module.exports = __webpack_public_path__ + "static/media/third.c6981512.gif";